import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=b55354a0&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=b55354a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55354a0",
  null
  
)

export default component.exports